import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useInfrastructureChartsDataContext } from './hooks/useInfrastructureChartsDataContext';

export const Lighting = () => {
    const { chartData } = useInfrastructureChartsDataContext();


    return (
        <SimpleBars
            title={'Iluminação'}
            horizontal={true}
            subtitles={chartData?.lighting?.map((item) => item.description)}
            values={chartData?.lighting?.map((item) => item.total  ||  0)}
        />
    );
};
